<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                {{ $t("task.task") }}
              </h3>
              <el-divider></el-divider>
              <el-input
                v-model="taskKeyword"
                size="medium"
                :placeholder="$t('task.putKeyword')"
                style="width: 300px"
              >
                <template v-slot:append>
                  <el-button
                    icon="el-icon-search"
                    @click="searchTask"
                  ></el-button>
                </template>
              </el-input>
              <br />
              <br />
              <el-table
                ref="filterTable"
                :data="taskList"
                @filter-change="filterChange"
                style="width: 100%"
                v-loading="loading"
              >
                <el-table-column
                  prop="name"
                  :label="$t('table.title')"
                  sortable
                  min-width="30%"
                  column-key="date"
                >
                </el-table-column>
                <el-table-column
                  prop="class"
                  :label="$t('table.class')"
                  min-width="20%"
                >
                  <template v-slot="scope">
                    {{ scope.row.groupNames | groupNameFilter }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  :label="$t('table.type')"
                  column-key="type"
                  min-width="10%"
                  :filters="typeChoices"
                  :filter-multiple="false"
                  filter-placement="bottom-end"
                >
                  <template v-slot="scope">
                    <el-tag
                      :type="taskTypeColorList[scope.row.type]"
                      disable-transitions
                      >{{ scope.row.type | taskTypeFilter(te) }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  :label="$t('table.status')"
                  column-key="status"
                  min-width="12%"
                  :filters="stateChoices"
                  :filter-multiple="false"
                  filter-placement="bottom-end"
                >
                  <template v-slot="scope">
                    <el-tag
                      :type="calTaskType(scope.row.status)"
                      disable-transitions
                      >{{ scope.row.status | taskStateFilter(te) }}</el-tag
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="delete"
                  :label="$t('table.operation')"
                  width="300"
                >
                  <template v-slot="scope">
                    <el-button
                      @click="checkTaskDetail(scope.row)"
                      type="primary"
                      size="small"
                      style="width: 100px; margin-left: 2rem"
                      >{{ $t("button.look") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalPage"
                style="float: right; margin: 20px"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
              >
              </el-pagination>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leftbar from "@/components/newComponent/Leftbar";
import { taskListGet } from "@/api/task";

import {
  taskTypeFilter,
  taskStateFilter,
  taskBadgeFilter,
  groupNameFilter,
} from "@/utils/filter";

export default {
  components: {
    Leftbar,
  },
  name: "task",
  bodyClass: "index-page",
  filters: {
    taskTypeFilter,
    taskStateFilter,
    taskBadgeFilter,
    groupNameFilter,
  },
  data() {
    return {
      checkMyTask: false,
      taskKeyword: "",
      pageSize: 2,
      totalPage: 1,
      taskList: [],
      queryBy: "",
      type: "",
      status: "",
      currentPage: 1,
      stateFilterList: [],
      columnFilter: {
        status: [],
        type: [],
      },
      loading: false,
      taskTypeColorList: ["warning", "primary", "danger"],
    };
  },
  mounted() {
    this.initTaskList();
  },
  methods: {
    filterChange(filter) {
      if (filter.status) {
        this.columnFilter.status = filter.status;
      }
      if (filter.type) {
        this.columnFilter.type = filter.type;
      }
      this.initTaskList();
    },
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row, column) {
      return row.address;
    },
    filterType(value, row) {
      this.type = value;
      return row.type === value;
    },
    filterState(value, row) {
      this.state = value;
      return row.state === value;
    },
    filterHandler(value, row, column) {
      const { property } = column;
      return row[property] === value;
    },
    calTaskType(state) {
      return taskBadgeFilter(state);
    },
    checkTaskDetail(row, event, column) {
      this.$router.push(`/task/detail/${row.id}`);
    },
    initTaskList() {
      this.loading = true;
      const queryBy = "participant";
      const type =
        this.columnFilter.type.length === 0 ? "" : this.columnFilter.type[0];
      const value =
        this.columnFilter.status.length === 0
          ? "all"
          : this.columnFilter.status[0];
      taskListGet(
        queryBy,
        this.taskKeyword,
        this.currentPage,
        type,
        value,
      ).then((res) => {
        this.taskList = res.content;
        this.totalPage = res.totalElements;
        this.loading = false;
      });
    },
    handleCurrentChange() {
      this.initTaskList();
    },
    searchTask() {
      this.initTaskList();
    },
    te(arg) {
      const hasKey = this.$te(arg);
      if (hasKey) {
        return this.$t(arg);
      }
      return arg;
    },
  },
  computed: {
    stateChoices() {
      return [
        { text: this.$t("filter.noStart"), value: 0 },
        { text: this.$t("filter.doing"), value: 1 },
        { text: this.$t("filter.marking"), value: 2 },
        { text: this.$t("filter.end"), value: 3 },
      ];
    },
    typeChoices() {
      return [
        { text: this.$t("filter.exam"), value: 0 },
        { text: this.$t("filter.exercise"), value: 1 },
        { text: this.$t("filter.contest"), value: 2 },
      ];
    },
  },
  watch: {
    checkMyTask() {
      this.initTaskList();
    },
  },
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
